// extracted by mini-css-extract-plugin
export default {"this":"Layout-module--this--2-pQr","content":"Layout-module--content--2eUHp"};